import React from 'react';

export const PageButton = props => {
    const p     = props;

    return (
        <div
            className   = { `pagination-buttons ml5${p.currentPage === p.pageNumber ? ' active' : ''}` }
            onClick     = { () => p.changePage() }
        >
            <span>
                { p.pageNumber }
            </span>
        </div>
    );
}
 
export default PageButton